export default {
    install(Vue, options) {
        Vue.directive("anchor-target", {
            /**
             * The directive anchor-target helping developer find and add 
             * your value target for anchor in html element
             * 
             * @param {HTMLElement} el
             * @param {Object} binding
             * @param {import("vue").VNode} vnode
             * @param {import("vue").VNode} oldVnode
             */
            bind(el, binding, vnode, oldVnode) {
                try {
                    const defaultTarget = "_self";
                    const targetValue = binding.value
                        ? binding.value
                        : defaultTarget;

                    // If current element is anchor tag, only add attribute for it
                    if (el.nodeName.toLowerCase() === "a") {
                        el.setAttribute("target", targetValue);
                    }
                    // anything else, to find children anchor and add new targetValue for all anchor items
                    else {
                        const anchors = el.querySelectorAll("a");

                        anchors.forEach((anchor) => {
                            // Only add new attribute for target attr has difference value
                            if (anchor.getAttribute("target") !== targetValue) {
                                anchor.setAttribute("target", targetValue);
                            }
                        });
                    }
                } catch (e) {
                    console.trace(e);
                }
            },
        });
    },
};



// WEBPACK FOOTER //
// ./src/plugins/AnchorPlugin/AnchorPlugin.js